import { getVistaFeatureFlag } from '@99designs/experiments';

// Determines enrollment into the request cart feature gate:
// https://console.statsig.com/5Yx4xlMFVM9VTFvZaUwBnI/gates/expert_services_requests_cart
export async function hasRequestCartFeatureFlag() {
    return getVistaFeatureFlag('expert_services_requests_cart', []);
}
